// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTASection_ctaSection__XtFfG","ctaTitle":"CTASection_ctaTitle__x9+vA","ctaDescription":"CTASection_ctaDescription__RpSwV","ctaButton":"CTASection_ctaButton__imEDv"};